/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Essentals

*/

import $ from 'jquery';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

NPM Packages

*/

import 'lazysizes/plugins/print/ls.print'; // needs to be BEFORE the main script
import 'lazysizes';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

allink CORE (NPM package)

===

These modules provide core functionality.

Note: Should you need a customzied project specific version of one of
the following modules:

Head over to the 'allink-core-static' repo, comment out the module below,
download the latest version and place it in the ./modules folder.

*/

import 'allink-core-static/js/modules/ajax-form';
import 'allink-core-static/js/modules/bootstrap-select';
import 'allink-core-static/js/modules/btn-ajax-loader';
import 'allink-core-static/js/modules/contact-form';
import 'allink-core-static/js/modules/datepicker';
import 'allink-core-static/js/modules/djangocms-tweaks';
import 'allink-core-static/js/modules/feature-detection';
import 'allink-core-static/js/modules/form';
// import 'allink-core-static/js/modules/form-modal';
import 'allink-core-static/js/modules/form-validation';
import 'allink-core-static/js/modules/full-height';
import 'allink-core-static/js/modules/image-modal';
import 'allink-core-static/js/modules/masonry';
import 'allink-core-static/js/modules/seo';
import 'allink-core-static/js/modules/site-overlay';
// import 'allink-core-static/js/modules/smooth-scroll';
import 'allink-core-static/js/modules/softpage';
import 'allink-core-static/js/modules/table';
import 'allink-core-static/js/modules/tingle';
import 'allink-core-static/js/modules/video';
import 'allink-core-static/js/modules/viewport-dimensions';
// import 'allink-core-static/js/modules/newsletter-collapse';
// import 'allink-core-static/js/modules/mailchimp';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Custom Scripts

*/

// import './modules/architonic';
import './modules/ajax-load-items';
import './modules/footer';
import './modules/header';
// import './modules/map';
import './modules/navigation';
import './modules/onscreen';
import './modules/parallax';
import './modules/swiper';
import './modules/to-the-top';
import './modules/advent';
import './modules/delayed_popup';
import './modules/appointment_picker';
import './modules/form-modal-2';
import './modules/form_modal_trigger';

$(function() {
  // $(window).on('softpage:opened',function(){
  //     var $softpage = $('.softpage');
  //     var $softpage_content_container = $softpage.find('.tingle-modal-box__content');
  //     var $ajax_page_container = $softpage.find('.ajax-page-container');
  //     if ($ajax_page_container.length > 0) {
  //         $softpage_content_container.empty().append($ajax_page_container);
  //     }
  // });

  const init_product_slider = function() {
    new Swiper('.product-swiper', {
      slidesPerView: 3,
      spaceBetween: 20,
      loop: false,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      pagination: '.swiper-pagination',
      paginationClickable: true,
      breakpoints: {
        677: {
          slidesPerView: 1,
        }
      }
    });
  };

  init_product_slider();

  $(window).on('softpage:opened',function(){
    init_product_slider();
  });
});



// WEBPACK FOOTER //
// ./static/js/app.js